export default __webpack_public_path__ + "static/apercu-regular-3ec8cf2bb96087f9162616ab7d1dda4d.woff";